import { render } from "./PoseCreate.vue?vue&type=template&id=5943182d&scoped=true"
import script from "./PoseCreate.vue?vue&type=script&lang=js"
export * from "./PoseCreate.vue?vue&type=script&lang=js"

import "./PoseCreate.vue?vue&type=style&index=0&id=5943182d&scoped=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5943182d"]])

export default __exports__